import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/19-1_clouddownload.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const CloudUploadAlt: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default CloudUploadAlt;
